import { FC } from 'react';
import RelatedGrid from '@components/relatedGrid/RelatedGrid';
import { SeeAll } from '@components/seeAll';
import { Title } from '@components/title';
import { ITipCard } from '@shared/models/tipsAndTricks.model';
import { ModuleType } from '@shared/types/module.type';
import { analytics } from '@shared/utils/segment.utils';
import { TipsContainer } from './RelatedTips.style';
interface Props {
  data: ITipCard[];
}
const RelatedTips: FC<Props> = ({
  data
}: Props) => {
  return <TipsContainer>
            <RelatedGrid cardType={ModuleType.TipsTricks} title={<Title text={'เคล็ดลับ ฉบับซีพี'} extra={<SeeAll url={`/search?c=${ModuleType.TipsTricks}`} onClick={() => {
      analytics.track('Related Tips Tricks See All Click', {
        event: 'Related Tips Tricks See All Click'
      });
    }} />} />} dataList={data} desktopColumn={3} mobileColumn={1} eventSection="Related Tips Tricks" />
            {/* <SkeletonTipsAndTricksCard /> //TODO Skeleton */}
        </TipsContainer>;
};
export default RelatedTips;